import React from "react";

import loadable from "@loadable/component";
import SupplierList from "../../components/Supplier/Supplier";

const SupplierListComponent = loadable(
  () => import("../../components/Supplier/Supplier")
);

const SupplierListPage = () => {
  return (
    <div>
      <SupplierListComponent />
    </div>
  );
};

export default SupplierListPage;

